export default "__VITE_ASSET__D5o$J$mY__"